import _ from "underscore";
import config from "../../config";
import {
    removeSelectiveNoScroll,
} from "../common/utils"
import {setSelectedCountry} from "./appAC";
import {ModelProductList} from "../common/ModelProductList";
import { availableCountries } from "../cart/common/available-countries-config"
import { getProductsQuery } from "./Shopify/shopify-queries/product"
import { formatShopifyProductsResponse } from "./Shopify/helpers"

export const storefrontApi = (query, variables) => {
    return fetch(`${config.host_rebag_shop}/api/2025-04/graphql`,
      {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': config.storefront_api.storefrontAccessToken
          },
          body: JSON.stringify({ query, variables })
      })
      .then(response => response.json());
}

const openShopifyCart = (for_trade_in = false) => {
    return (dispatch, _) => {
        if(for_trade_in){
            dispatch({
                type: 'TRADE_IN_ACTIVE',
                for_trade_in: for_trade_in
            })
        }
        dispatch({
            type: 'TOGGLE_CART',
            payload: true
        })
    }
}

const closeShopifyCart = () => {
    return (dispatch, getState) => {
        if(window.location.href.search('cart') !== -1){
            const url = new URL(window.location);
            url.searchParams.delete('cart');
            window.history.replaceState({}, '', url);
        }

        removeSelectiveNoScroll("no-scroll--cart");
        dispatch({
            type: "CLOSE_CART",
        })
        dispatch({type: 'HIDE_SPINNER'})
    }
}

const setRecentlyViewed = (product_ids) => {
    return (dispatch) => {
        const variables = {ids: product_ids};
        storefrontApi(getProductsQuery, variables).then(formatShopifyProductsResponse).then((products) => {
            return ModelProductList(products);
        }).then((recently_viewed_products) => {
            dispatch({
                type: "SET_RECENTLY_VIEWED",
                recently_viewed_products: recently_viewed_products
            })
        });
    }
};

const setShopifyFavorites = (product_ids) => {
    return (dispatch) => {
        const variables = {ids: product_ids};
        storefrontApi(getProductsQuery, variables).then(formatShopifyProductsResponse).then((products) => {
            return ModelProductList(products);
        }).then((shopify_favorites_list) => {

            const shopify_favorites_list_available = _.filter(shopify_favorites_list, function(product){ return product.availableForSale; });
            const shopify_favorites_list_unavailable = _.filter(shopify_favorites_list, function(product){ return !product.availableForSale; });
            dispatch({
                type: "SET_SHOPIFY_FAVORITES",
                shopify_favorites_list: shopify_favorites_list,
                shopify_favorites_list_available: shopify_favorites_list_available,
                shopify_favorites_list_unavailable: shopify_favorites_list_unavailable
            });
            dispatch({type: "HIDE_SPINNER"});
        });
    }
};

const getStoreAvailableCountries = () => {
    return (dispatch) => {
        return new Promise (async (resolve) => {
            dispatch({
                type: 'SET_AVAILABLE_COUNTRIES',
                payload: availableCountries,
            });
            dispatch(setSelectedCountry()).then(() => {
                resolve();
            });
        })
    }
}

export {
    setRecentlyViewed,
    setShopifyFavorites,
    openShopifyCart,
    closeShopifyCart,
    getStoreAvailableCountries,
}
